module.exports = __webpack_public_path__ + "img/sunny-pro.4e9ed4f8.jpg";